import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HurtownikDetailPage } from "@/features/hurtownicy/components/hurtownik-detail";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	tokenId: z.coerce.number().int().positive().optional(),
	paymentDueFrom: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
	paymentDueTo: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
});

export const Route = createFileRoute("/_auth/dokumenty/hurtownicy/$nip")({
	validateSearch: (search) => searchSchema.parse(search),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.dokumenty.hurtownicy",
			location.pathname,
		);
	},
	component: HurtownikDetailRoute,
});

function HurtownikDetailRoute() {
	const { nip } = Route.useParams();
	const { tokenId, paymentDueFrom, paymentDueTo } = Route.useSearch();
	return (
		<HurtownikDetailPage
			nip={nip}
			tokenId={tokenId}
			paymentDueFrom={paymentDueFrom}
			paymentDueTo={paymentDueTo}
		/>
	);
}
